import {createAsyncThunk} from '@reduxjs/toolkit';
import {integrationsApi} from 'api';
import {IIntegrationType} from 'models/integrations';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchIntegrationTypesThunk: any = createAsyncThunk<IIntegrationType[], any>(
  `${prefix} fetchIntegrationTypes`,
  async (_, {dispatch, rejectWithValue}) => {
    try {
      const {parsedBody} = await integrationsApi.getIntegrationTypes();
      return parsedBody;
    } catch (error) {
      dispatch(toastNotificationManager.createErrorToastAction(error.parsedBody));
      return rejectWithValue({error});
    }
  }
);
